import { render, staticRenderFns } from "./KkmSetPointForm.vue?vue&type=template&id=012e652c&"
import script from "./KkmSetPointForm.vue?vue&type=script&lang=js&"
export * from "./KkmSetPointForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports